import React from "react"
import { VictoryLine } from "victory"
import PropTypes from "prop-types"

const Line = ({ timeslices, bare, gradientID, gradientFn }) => {
  let stroke

  // HACK: if you try to render a straight line with a gradient, the line disappears. No idea why, definitely a Victory bug.
  if (
    timeslices.every(
      v => v.peakUtilizedCount === timeslices[0].peakUtilizedCount
    )
  ) {
    stroke = gradientFn(timeslices[0].peakUtilizedCount)
  } else {
    stroke = `url(#${gradientID})`
  }

  return (
    <VictoryLine
      style={{
        data: {
          stroke: stroke,
          strokeWidth: "2.5",
          strokeLinecap: "round",
        },
      }}
      interpolation={bare ? "monotoneX" : "linear"}
      data={timeslices.map((timeslice, i) => ({
        x: i + 1, // needed to create round tip on left side
        y: timeslice.peakUtilizedCount,
      }))}
    />
  )
}

Line.propTypes = {
  timeslices: PropTypes.arrayOf(
    PropTypes.shape({
      peakUtilizedCount: PropTypes.number.isRequired,
    }).isRequired
  ).isRequired,
  bare: PropTypes.bool,
  gradientID: PropTypes.string,
  gradientFn: PropTypes.func,
}

export default Line
